"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/healthSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type HealthSection2346sItem = {
    key: Key | null | undefined;
    /** Detected variants: "health-item-thirteen wow fadeInUp" | "health-item-thirteen two wow fadeInUp" | "health-item-thirteen three wow fadeInUp" | "health-item-thirteen four wow fadeInUp" | "health-item-thirteen five wow fadeInUp" | "health-item-thirteen six wow fadeInUp" */
    className: string;
    /** Detected variants: "1s" | "2s" | "3s" | "4s" | "5s" | "6s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/icons/health-icon-1.svg" | "/Templates/Doccure/img/icons/health-icon-2.svg" | "/Templates/Doccure/img/icons/health-icon-3.svg" | "/Templates/Doccure/img/icons/health-icon-4.svg" | "/Templates/Doccure/img/icons/health-icon-5.svg" | "/Templates/Doccure/img/icons/health-icon-6.svg" */
    src: string;
    /** Detected variants: "Liver Care" | "Dental Care" | "Heart Care" | "Orthopedic" | "Kidney Care" | "Respiratory Care" */
    link0Text: ReactNode;
    /** Detected variants: "col-xl-2 col-lg-3 col-md-4 col-sm-6" */
    divClassName?: string;
    /** Detected variants: "health-overlay" */
    div0ClassName?: string;
    /** Detected variants: "health-icon" */
    div0ClassName2?: string;
    /** Detected variants: "health" */
    alt?: string;
    /** Detected variants: "img-fluid icon-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "shadow-1" */
    div1ClassName?: string;
    /** Detected variants: "shadow-2" */
    div2ClassName?: string;
    /** Detected variants: "health-content" */
    div1ClassName2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeThirteenHealthSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HealthSection2346sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: HealthSection2346sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HealthSection2346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Shop by Health Concerns" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "#" */
    sectionDiv0Div0Link0LinkHref?: string;
    /** Default: "View All" */
    sectionDiv0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv0Div1ClassName?: string;
    healthSection2346s: HealthSection2346sItem[];
    healthSection2346sItemWrapper?: (item: HealthSection2346sItem, content: ReactNode) => ReactNode;
    healthSection2346sRenderer?: (defaultNode: ReactNode) => ReactNode;
    healthSection2346sLinkVisible?: boolean;
    healthSection2346sLinkRenderer?: (item: HealthSection2346sItem, defaultNode: ReactNode) => ReactNode;
    healthSection2346sImageVisible?: boolean;
    healthSection2346sImageRenderer?: (item: HealthSection2346sItem, defaultNode: ReactNode) => ReactNode;
    healthSection2346sH3Visible?: boolean;
    healthSection2346sH3Renderer?: (item: HealthSection2346sItem, defaultNode: ReactNode) => ReactNode;
    healthSection2346sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HealthSection2346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    healthSection2346sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HealthSection2346sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    healthSection2346sH3Props?: Partial<ComponentProps<"h3">> | ((item: HealthSection2346sItem) => Partial<ComponentProps<"h3">>);
};

const HomeThirteenHealthSectionGenerated: FC<HomeThirteenHealthSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Shop by Health Concerns",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0Link0LinkHref = "#",
    sectionDiv0Div0Link0LinkText = "View All",
    sectionDiv0Div0Link0LinkVisible,
    sectionDiv0Div0Link0LinkRenderer,
    sectionDiv0Div0Link0LinkProps,
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    healthSection2346s,
    healthSection2346sItemWrapper,
    healthSection2346sRenderer,
    healthSection2346sLinkVisible,
    healthSection2346sLinkRenderer,
    healthSection2346sImageVisible,
    healthSection2346sImageRenderer,
    healthSection2346sH3Visible,
    healthSection2346sH3Renderer,
    healthSection2346sLinkProps,
    healthSection2346sImageProps,
    healthSection2346sH3Props,
}) => {
    return (
        <section className="health-section-thirteen section">
            <div className="container">
                <div className="section-header section-header-thirteen wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    {renderNode(sectionDiv0Div0Link0LinkVisible, sectionDiv0Div0Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div0Link0LinkHref} className="btn theme-12-btn" {...(sectionDiv0Div0Link0LinkProps ?? {})}>
                            {sectionDiv0Div0Link0LinkText}
                            <i className="isax isax-arrow-right-1 ms-2" />
                            {" "}
                        </SmartLink>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        healthSection2346s,
                        (item: HealthSection2346sItem) => (
                            <div className={item.divClassName ?? "col-xl-2 col-lg-3 col-md-4 col-sm-6"} key={item.key}>
                                <div className={item.className} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName ?? "health-overlay"}>
                                        <div className={item.div0ClassName2 ?? "health-icon"}>
                                            {renderItemNode(healthSection2346sImageVisible, healthSection2346sImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "health"} className={item.imageWithBasePath0ClassName ?? "img-fluid icon-1"} {...(typeof healthSection2346sImageProps === "function" ? healthSection2346sImageProps(item) : (healthSection2346sImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        <div className={item.div1ClassName ?? "shadow-1"} />
                                        <div className={item.div2ClassName ?? "shadow-2"} />
                                    </div>
                                    <div className={item.div1ClassName2 ?? "health-content"}>
                                        {renderItemNode(healthSection2346sH3Visible, healthSection2346sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof healthSection2346sH3Props === "function" ? healthSection2346sH3Props(item) : (healthSection2346sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(healthSection2346sLinkVisible, healthSection2346sLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} {...(typeof healthSection2346sLinkProps === "function" ? healthSection2346sLinkProps(item) : (healthSection2346sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ),
                        healthSection2346sItemWrapper,
                        healthSection2346sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeThirteenHealthSectionGenerated;
